import React, {useRef, useState, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {animated, useSpring} from 'react-spring';

import {expandLayoutList, triggerLayoutList} from '../../../store/layouts/actions';
import {ApplicationState} from '../../../store';
import {LayoutState} from '../../../store/layouts/types';
import closeIcon from '../../../assets/images/close.png';
import expandIcon from '../../../assets/images/expand-icon.png';
import viewIcon from '../../../assets/images/view-icon.png';
import CloseIconComponent from "../../reusable/CloseIconComponent";

interface Props {
    searchHandler: (searchHandler: React.FormEvent<HTMLInputElement>) => void
    value: string
}

const ListLayoutTitleComponent: React.FC<Props> = ({ searchHandler, value }) => {
    const ref = useRef<HTMLInputElement>(null);
    const dispatch = useDispatch();
    const { openedLayoutList, expandedLayoutList } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const expandRef = useRef<HTMLDivElement | null>(null);
    const transition = useSpring({
        transform: expandedLayoutList ? 'rotate(90deg)' : 'rotate(0deg)'
    });

    const closeHandler = () => dispatch(triggerLayoutList(!openedLayoutList));
    const expandHandler = () => dispatch(expandLayoutList(!expandedLayoutList));

    useEffect(() => {
        ref.current && ref.current.focus();
    }, []);


    return(
        <div className='list-view-wrapper'>
            <div className='list-view-bg'>
                <img src={ viewIcon } height='32px'/>
                <div className='list-view-title'>
                    Views
                </div>
                <div className='layoutlist-title-search'>
                    <input type="text"
                        onChange={ searchHandler }
                        onClick={(e) => e.stopPropagation()}
                        value={value}
                        ref={ref}
                    />
                </div>
                <animated.div className='list-view-expand-wrapper pointer'
                              style={transition}
                              ref={expandRef}
                              onClick = { expandHandler } >
                    <img src={ expandIcon } width='24px'/>
                </animated.div>
            </div>
            <CloseIconComponent handler={closeHandler}/>
        </div>
    )
};

export default ListLayoutTitleComponent